import { ApolloClient, InMemoryCache } from '@apollo/client'

export const client = new ApolloClient({
  uri: process.env.REACT_APP_BACKEND_GRAPHQL_URL,
  headers: {
    authorization: `Bearer ${process.env.REACT_APP_BACKEND_GRAPHQL_TOKEN}`,
    'x-brikl-shop-id': `${process.env.REACT_APP_SHOP_ID}`,
  },

  cache: new InMemoryCache(),
})
